import React, { useState, useEffect } from 'react';

const RelatedProductsView = ({ product }) => {
  const [isRendered, setIsRendered] = useState(false);

  // This effect now runs only once when the component is first mounted
  useEffect(() => {
    const timer = setTimeout(() => setIsRendered(true), 50); // Delay to trigger animation
    return () => clearTimeout(timer);
  }, []); // Empty dependency array ensures it runs only on mount

  return (
    <div className={`related-products-container ${isRendered ? 'visible' : ''}`}>
      {product.products.map((item, index) => (
        <div key={index} className="related-product-item" style={{ transitionDelay: `${index * 100}ms` }}>
          {item}
        </div>
      ))}
    </div>
  );
};

export default RelatedProductsView;